import L from 'leaflet'
import t from '@/libs/i18n'
import moment from 'moment'
// import mapCommon from "@/views/modules/maps/functions/mapCommon";
// const {  myPopup } = mapCommon()
import store from '@/store'
import { ref } from '@vue/composition-api'
import axios from 'axios'
const currentAddress=ref('')
export default function Marker() {
  const getPointAddress=(point)=>{

    return new Promise((resolve, reject) => {
      axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${point.lat.toFixed(5)}&lon=${point.lng.toFixed(5)}` )
         .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
    
   
  }
// currentAddress.value=res.data.display_name;
  /**
   * create marker
   * @param point
   * @returns {*}
   */
  const create = (point) =>
  {
    const icon = createIcon(point)
    return  L.marker([parseFloat(point.latitude), parseFloat(point.longitude)], {icon: icon})
      .bindPopup(myPopup(point))
  }


  /**
   * update device info and move on map
   * @param marker
   * @param device
   * @param message
   */
  const update_device = (marker, device, message) => {
    //
    // console.log("marker", marker)
    // console.log("message", message)
    // console.log("device", device)

    if (device !== undefined && marker !== undefined) {
      // console.log(message)
      // console.log(device)
      Object.keys(message).forEach(key => Object.keys(device).includes(key) ? device[key] = message[key] : false)
      move_marker(marker, device)
    }
  }


  const move_marker = (marker, device) => {
    const icon = createIcon(device, true)
    marker.setLatLng(new L.LatLng(device.latitude, device.longitude));
    marker.setIcon(icon)
    marker.on('click', function(e){
      
      marker._popup.setContent(myPopup(device))
    })
  }


  /**
   * create marker icon
   * @param device
   * @param withLabel
   * @returns {*}
   */
  const createIcon = (device, withLabel = false) =>
  {
    const label = withLabel ?
      `<div class="m-label" style="color:${device.color}">${device.name}</div>` : ''

    let img;

    try {
      img = require('@/assets/markers/'+device.category+'/'+device.status+'.svg')
    } catch (e) {
      img = require('@/assets/markers/'+device.status+'.svg')
    }


    return L.divIcon({
      html: L.Util.template(`<div>${label}<div class="rotate-${device.course}"><img src="${img}" alt=""></div></div>`),
      iconSize    : [30, 40], })
  }




  const createCustomIcon = (customImg,lablelText,color) =>
  {
    const label =
      `<div class="mx-label" style="color:${color}">${lablelText}</div>` 

    const img = require('@/assets/markers/'+customImg+'.svg')
    return L.divIcon({
      html: L.Util.template(`<div>${label}<div class="rotate-0"><img src="${img}" alt=""></div></div>`),
      iconSize    : [30, 40], })
  }



  const myPopup = (point) => 
  `<div class="custom-popup" style="direction:${store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'}" >
      <div class="header">${point.name}</div>
      <div class="contract">${point.contract_name}</div>
      <table class="custom-popup-table">

          <tr>
          <td>${t.t('plate')}</td>
          <td class="float-endx">${point.plate}</td>
          </tr>
          <tr>
           <td>${ t.t('category') }</td>
           <td class="float-endx">${point.category}</td>
         </tr>
         <tr>
           <td>${ t.t('speed') }</td>
           <td class="float-endx">${point.speed+' '+t.t('km/h')}</td>
         </tr>
          <tr>
           <td>${ t.t('status') }</td>
           <td class="float-endx">${point.status}</td>
         </tr>   
           <tr>
           <td>${ t.t('lastupdate') }</td>
           <td class="float-endx">${ moment(point.lastupdate).fromNow() }</td>
         </tr>
         <tr>
         <td>${t.t('owner')}</td>
         <td>${point.owner_name}</td>
         </tr>
         <tr>
          <td>${t.t('location')}</td>
          <td> <a target="_blank"  href="https://maps.google.com/maps?q=${point.latitude+','+point.longitude}">${point.latitude+','+point.longitude} </a> </td>
        
          </tr>
        
      </table>
    </div>`



  return {
    create,
    createIcon,
    move_marker,
    update_device,createCustomIcon
  }

}
